import { Component, inject, OnInit, OnDestroy, ChangeDetectionStrategy } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialogRef,
  MatDialogClose,
  MatDialogTitle,
  MatDialogContent,
  MatDialogActions,
} from '@angular/material/dialog';
import { MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { L10nTranslationModule } from 'angular-l10n';
import { CdkScrollable } from '@angular/cdk/scrolling';
@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'miq-outdated-records-alert',
  templateUrl: './outdated-records-alert.component.html',
  styleUrl: './outdated-records-alert.component.scss',
  imports: [
    MatButton,
    MatDialogClose,
    MatIcon,
    MatDialogTitle,
    CdkScrollable,
    MatDialogContent,
    MatDialogActions,
    L10nTranslationModule
],
})
export class OutdatedRecordsAlertComponent implements OnInit, OnDestroy {
  private readonly dialogRef = inject(MatDialogRef<OutdatedRecordsAlertComponent>);
  public context = inject<string>(MAT_DIALOG_DATA);
  ngOnInit() {
    /* required for static lable translation */
  }
  onClose() {
    this.dialogRef.close();
  }
  onUpdate() {
    this.dialogRef.close('update');
  }
  ngOnDestroy() {
    /** label translation purpose added */
  }
}
